export default __webpack_public_path__ + "static/media/ExportIcon.222f99f2.svg";